<template>
  <v-app id="inspire" light>
    <loadingcomp
      v-bind:mesaj="loadingmesaj"
      v-model="loadingvmodel"
    ></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <v-toolbar size="120px" dark color="info">
      <v-toolbar-title>{{ this.$t("Visa-Tracking-List") }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-flex xs12 sm3 md3>
        <v-text-field
          flat=""
          prepend-inner-icon="live_help"
          v-model="RequestData.Filtreler.SearchText"
          solo-inverted=""
          hide-details
          :label="this.$t('Search')"
          @click:append="getListPageZero()"
          append-icon="search"
        >
          <v-tooltip slot="prepend-inner" bottom>
            <v-icon slot="activator" color="primary" dark>live_help</v-icon>
            <span> {{ this.$t("Fields-Which-Can-be-Searched") }} </span><br />
            <v-divider color="yellow"></v-divider>
          </v-tooltip>
        </v-text-field>
      </v-flex>
    </v-toolbar>

    <!-- Search Bar -->
    <v-flex xs12 sm12 md12 class="ma-3">
      <v-card class="pa-3" flat>
        <v-layout row wrap>
          <v-flex xs12 sm4 md2>
            <tarihim
              v-model="RequestData.Filtreler.Kayit_Tarihi1"
              :etiket="this.$t('Registration-Starting-Date')"
              v-bind:defaultvalue="'ok'"
            ></tarihim>
          </v-flex>
          <v-flex xs12 sm2 md2>
            <tarihim
              v-model="RequestData.Filtreler.Kayit_Tarihi2"
              :etiket="this.$t('Registration-Ending-Date')"
              v-bind:defaultvalue="'ok'"
            ></tarihim>
          </v-flex>
          <v-flex xs12 sm2 md2>
            <v-btn color="info" @click="getList()" fab small dark>
              <v-icon>search</v-icon>
            </v-btn>
           
             
            <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn color="info" @click="getListExcel()"  v-on="on" fab small dark>
              <v-icon>cloud_download</v-icon>
            </v-btn>
      </template>
      <span>Excel İndir</span>
    </v-tooltip>
           
            
          
            <v-btn small ref="fab" color="info" @click="filter = true" fab dark>
              <v-icon>filter_list</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <!-- Filtreler ve Sayfalama -->
    <v-flex xs12 sm12 md12 pl-3 pr-3>
      <v-card width="100%" flat color="grey lighten-5">
        <v-layout row wrap align-center>
          <v-flex
            xs12
            sm12
            md9
            class="headline font-weight-regular pl-3 grey--text"
          >
            {{ totalCountText }}
          </v-flex>
          <v-flex xs12 sm12 md2 pt-2>
            <v-select
              :label="this.$t('Sort-By')"
              :items="siralamaItems"
              item-text="Text"
              item-value="Value"
              @change="getListPageZero()"
              v-model="RequestData.Paging.SiralamaTip"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm12 md1 pt-2>
            <v-select
              :label="this.$t('Show')"
              :items="veriItem"
              item-text="Text"
              item-value="Value"
              @change="getListPageZero()"
              v-model="RequestData.Paging.VeriAdet"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <!-- Listeleme -->
    <v-container fluid grid-list-sm>
      <v-flex
        v-for="item in cardItems"
        v-bind:key="item.SiraNo"
        pb-3
        xs12
        sm12
        md12
      >
        <v-hover>
          <v-card
            width="100%"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            class="elevation-1 pa-3"
          >
            <v-layout row wrap align-center justify-end>
              <v-flex xs12 sm6 md2>
                <v-layout row wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-medium grey--text body-1"
                  >
                    <v-icon color="#67768f" small>fiber_manual_record</v-icon>
                    {{ item.PNR_No }}
                    <v-icon color="#67768f" v-if="item.TakipNo != null" small
                      >fiber_manual_record</v-icon
                    >
                    {{ item.TakipNo }}
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-medium grey--text body-1"
                  >
                    <v-icon color="#67768f" small>supervisor_account</v-icon>
                    {{ item.Isim }}
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-bold grey--text body-1"
                  >
                    <v-icon color="#67768f" small>payment</v-icon>
                    {{ item.Cari_Kod }}
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-large grey--text caption"
                >
                  <v-btn
                    outline
                    @click="pasaportDurumuDegistirDialogOpen(item)"
                    :color="getPasaportColor(item.PasaportIslemDurumu)"
                  >
                    {{
                      item.PasaportIslemDurumu
                        | getPasaportDurumu(pasaportIslemItems)
                    }}
                  </v-btn>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-large grey--text caption"
                >
                  <v-btn
                    outline
                    @click="vizeDurumuDegistirDialogOpen(item)"
                    :color="getVizeColor(item.VizeIslemDurumu)"
                  >
                    {{ item.VizeIslemDurumu | getVizeDurumu(vizeIslemItems) }}
                  </v-btn>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-layout row wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-large grey--text pl-2 caption"
                  >
                    <v-icon color="info">tour</v-icon>
                    <span style="color: #67768f"> {{ item.KonsAdi }}</span>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-large grey--text pl-2 caption"
                  >
                    <span style="color: #67768f"> Pasaport No :</span>
                    {{ item.PasaportNo }}
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-large grey--text pl-2 caption"
                  >
                    <span style="color: #67768f"> Vize No :</span>
                    {{ item.VizeNo }}
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-flex
                  xs12
                  sm12
                  md12
                  style="color: #67768f"
                  class="font-weight-large grey--text body-1"
                >
                  <span style="color: #67768f"> Kayıt Tarihi :</span>
                  {{ item.Kayit_Tarihi | dateformat }}
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  style="color: #67768f"
                  class="font-weight-large grey--text body-1"
                >
                  <span style="color: #67768f">Vize Başlangıç :</span
                  >{{ item.VizeBaslangicTarihi | dateformat }}
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  style="color: #67768f"
                  class="font-weight-large grey--text body-1"
                >
                  <span style="color: #67768f">Vize Bitiş Tarihi :</span
                  >{{ item.VizeBitisTarihi | dateformat }}
                </v-flex>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-flex
                  xs12
                  sm12
                  md12
                  style="color: #67768f"
                  class="font-weight-large grey--text body-1"
                >
                  <span style="color: #67768f"> İskonto Tutar :</span>
                  {{ item.IskTutar | moneyformat }}
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  style="color: #67768f"
                  class="font-weight-large grey--text body-1"
                >
                  <span style="color: #67768f"> İskonto Oranı :</span
                  >{{ item.IskYuzde }}
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  style="color: #67768f"
                  class="font-weight-large grey--text body-1"
                >
                  <span style="color: #67768f"> İskonto Vergi :</span
                  >{{ item.Isk_KDV }}
                </v-flex>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-large grey--text body-2"
                >
                  <span style="color: #67768f"> Alış Toplam :</span>
                  {{ item.PaxAlis | moneyformat }} {{ item.ParaAlis }}
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-large grey--text body-2"
                >
                  <span style="color: #67768f"> Satış Toplam :</span>
                  {{ item.PaxSatis | moneyformat }} {{ item.ParaSatis }}
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card>
        </v-hover>
      </v-flex>
    </v-container>

    <!-- sayfalama -->
    <template v-if="vmodelpagination">
      <div class="text-xs-center">
        <v-container>
          <v-layout justify-center>
            <v-flex xs8>
              <v-pagination
                :disabled="paginationDisabled"
                color="info"
                v-model="sayfalama"
                :length="pagenumber"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>
    <!-- Filter Dialog -->
    <v-dialog
      v-model="filter"
      persistent
      max-width="700px"
      @keydown.esc="filter = false"
    >
      <v-card>
        <v-card-title style="background-color: #01579b">
          <span class="headline white--text">{{ this.$t("Filters") }}</span>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-flex xs12 md12 sm12>
            <v-layout row wrap>
              <v-flex xs12 sm12 md6>
                <v-select
                  v-model="RequestData.Filtreler.PasaportIslemDurumu"
                  hide-details
                  :items="pasaportIslemItemsDialog"
                  :label="this.$t('Passport-Process-Status')"
                  item-text="text"
                  item-value="value"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-select
                  hide-details
                  v-model="RequestData.Filtreler.VizeIslemDurumu"
                  :items="vizeIslemItemsDialog"
                  :label="this.$t('Visa-Process-Status')"
                  item-text="text"
                  item-value="value"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-form ref="formPNR" lazy-validation>
                  <pnrbul hide-details v-model="RequestData.Filtreler.PNR_No">
                  </pnrbul>
                </v-form>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <konsoloslukminiara v-model="RequestData.Filtreler.Konsolosluk">
                </konsoloslukminiara>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <takipno v-model="RequestData.Filtreler.TakipNo" hide-details>
                </takipno>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <geneltipara
                  tip="AcenteDepartman"
                  v-model="RequestData.DepartmanID"
                ></geneltipara>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  :label="this.$t('Name')"
                  v-model="RequestData.Filtreler.Isim"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md6>
                    <tarihim
                      v-model="RequestData.Filtreler.PasaportBitisTarihi1"
                      :etiket="this.$t('Passport-Starting-Date')"
                      v-bind:defaultvalue="'no'"
                    ></tarihim>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <tarihim
                      v-model="RequestData.Filtreler.PasaportBitisTarihi2"
                      :etiket="this.$t('Passport-Expiry-Date')"
                      v-bind:defaultvalue="'no'"
                    ></tarihim>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12 pt-2>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md6>
                    <tarihim
                      v-model="RequestData.Filtreler.VizeBitisTarihi1"
                      :etiket="this.$t('Visa-Starting-Date')"
                      v-bind:defaultvalue="'no'"
                    ></tarihim>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <tarihim
                      v-model="RequestData.Filtreler.VizeBitisTarihi2"
                      :etiket="this.$t('Visa-Expiry-Date')"
                      v-bind:defaultvalue="'no'"
                    ></tarihim>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12 pt-2>
                <t row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-alert :value="true" color="success" icon="new_releases">
                      Pasaport ve Vize Durumu Değişiklik Tarihine Göre Arama
                    </v-alert>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <tarihim
                      v-model="RequestData.Filtreler.DegisiklikTarihi1"
                      :etiket="this.$t('Change-Starting-Date')"
                      v-bind:defaultvalue="'no'"
                    ></tarihim>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <tarihim
                      v-model="RequestData.Filtreler.DegisiklikTarihi2"
                      :etiket="this.$t('Change-Starting-Date')"
                      v-bind:defaultvalue="'no'"
                    ></tarihim>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-select
                      v-model="
                        RequestData.Filtreler.DegisiklikPasaportIslemDurumu
                      "
                      hide-details
                      :items="pasaportIslemItems"
                      :label="this.$t('Change-Passport-Process-Status')"
                      item-text="text"
                      item-value="value"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-select
                      hide-details
                      v-model="RequestData.Filtreler.DegisiklikVizeIslemDurumu"
                      :items="vizeIslemItems"
                      :label="this.$t('Change-Visa-Process-Status')"
                      item-text="text"
                      item-value="value"
                    >
                    </v-select>
                  </v-flex>
                </t>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="filter = false">{{
            this.$t("Cancel")
          }}</v-btn>
          <v-btn color="info" flat @click="getListPageZero()">
            {{ this.$t("Apply-Filters") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Vize Durumu Dialog -->
    <v-dialog
      v-model="vizeDurumuDialog"
      persistent
      max-width="500px"
      @keydown.esc="vizeDurumuDialog = false"
    >
      <v-card>
        <v-card-title style="background-color: #01579b">
          <span class="headline white--text">
            {{ this.$t("Change-Visa-Status") }}
          </span>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-flex xs12 md12 sm12>
            <v-layout row wrap>
              <v-flex xs12 sm12 md6>
                <v-select
                  hide-details
                  v-model="vizeDurumuRequest.VizeDurumu"
                  :items="vizeIslemItems"
                  :label="this.$t('Visa-Process-Status')"
                  item-text="text"
                  item-value="value"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-text-field
                  :label="this.$t('Visa-No')"
                  v-model="vizeDurumuRequest.VizeNo"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md6>
                    <tarihim
                      :etiket="this.$t('Visa-Starting-Date')"
                      v-bind:defaultvalue="'no'"
                      v-model="vizeDurumuRequest.VizeBaslangic"
                    ></tarihim>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <tarihim
                      :etiket="this.$t('Visa-Expiry-Date')"
                      v-bind:defaultvalue="'no'"
                      v-model="vizeDurumuRequest.VizeBitis"
                    ></tarihim>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="vizeDurumuDialog = false">{{
            this.$t("Cancel")
          }}</v-btn>
          <v-btn color="info" flat @click="vizeDurumuDegistir()">
            {{ this.$t("OK") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Pasaport Durumu Dialog -->
    <v-dialog
      v-model="pasaportDurumuDialog"
      persistent
      max-width="800px"
      @keydown.esc="pasaportDurumuDialog = false"
    >
      <v-card>
        <v-card-title style="background-color: #01579b">
          <span class="headline white--text">
            {{ this.$t("Change-Passport-Status") }}
          </span>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-flex xs12 md12 sm12>
            <v-layout row wrap>
              <v-flex xs12 sm12 md6>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-select
                      v-model="passRequest.PasaportDurumBilgi.PasaportTip"
                      hide-details
                      :items="pasaportTipItems"
                      label="Pasapor Tip"
                      item-text="text"
                      item-value="value"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :label="this.$t('Passport-No')"
                      v-model="passRequest.PasaportDurumBilgi.PasaportNo"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :label="this.$t('Place-Issue')"
                      v-model="passRequest.PasaportDurumBilgi.VerildigiYer"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6>
                        <tarihim
                          v-model="passRequest.PasaportDurumBilgi.VerilisTarihi"
                          :etiket="this.$t('Date-Issue')"
                          v-bind:defaultvalue="
                            passRequest.PasaportDurumBilgi.VerilisTarihi
                          "
                        ></tarihim>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <tarihim
                          v-model="passRequest.PasaportDurumBilgi.BitisTarihi"
                          :etiket="this.$t('Finishing-Date')"
                          v-bind:defaultvalue="
                            passRequest.PasaportDurumBilgi.BitisTarihi
                          "
                        ></tarihim>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      small
                      hide-details
                      v-model="passRequest.PasaportDurumBilgi.CocukVar"
                      color="green"
                      :label="this.$t('Passport-Includes-Children')"
                    >
                    </v-checkbox>
                    <v-flex xs12 sm12 md12>
                      <v-checkbox
                        small
                        hide-details
                        v-model="
                          passRequest.PasaportDurumBilgi.CocukVizeIstiyor
                        "
                        color="green"
                        :label="this.$t('Children-Passport-Requested')"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <genelarama
                        apiname="KullaniciAra"
                        v-model="passRequest.PasaportDurumBilgi.CocukId"
                        :label="this.$t('Search-Children-Address')"
                      ></genelarama>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-select
                      hide-details
                      :items="pasaportIslemItems"
                      v-model="
                        passRequest.PasaportDurumBilgi.PasaportIslemDurumu
                      "
                      :label="this.$t('Passport-Process-Status')"
                      item-text="text"
                      item-value="value"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :label="this.$t('Person-Receiving-Passport-Office-v2')"
                      v-model="passRequest.PasaportDurumBilgi.OfiseTeslimAlan"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :label="this.$t('Consulate')"
                      v-model="pasKonsAdi"
                      :disabled="true"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <tarihim
                      v-model="passRequest.PasaportDurumBilgi.OfiseGelisTarihi"
                      :etiket="this.$t('Date-Passports-Receiving-Office')"
                      v-bind:defaultvalue="
                        passRequest.PasaportDurumBilgi.OfiseGelisTarihi
                      "
                    ></tarihim>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout
                      row
                      wrap
                      style="max-height: 50px"
                      align-center
                      justify-center
                      fill-height
                    >
                      <v-flex xs7 sm7 md7>
                        <tarihim
                          v-model="
                            passRequest.PasaportDurumBilgi
                              .KonsoloslukGirisZamani
                          "
                          :etiket="this.$t('Consulate-Entry-Date')"
                          :detaygizle="false"
                          v-bind:defaultvalue="
                            passRequest.PasaportDurumBilgi
                              .KonsoloslukGirisZamani
                          "
                        ></tarihim>
                      </v-flex>

                      <v-flex xs5 sm5 md5>
                        <v-text-field
                          :label="this.$t('Consulate-Entry-Time')"
                          type="time"
                          v-model="konsoloslukGirisSaat"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout
                      row
                      wrap
                      style="max-height: 50px"
                      align-center
                      justify-center
                      fill-height
                    >
                      <v-flex xs7 sm7 md7>
                        <tarihim
                          v-model="
                            passRequest.PasaportDurumBilgi.TahminiCikisZamani
                          "
                          :etiket="this.$t('Estimated-Date-Leaving')"
                          :detaygizle="false"
                          v-bind:defaultvalue="
                            passRequest.PasaportDurumBilgi.TahminiCikisZamani
                          "
                        ></tarihim>
                      </v-flex>

                      <v-flex xs5 sm5 md5>
                        <v-text-field
                          :label="this.$t('Estimated-Time-Leaving')"
                          type="time"
                          v-model="tahminiCikisSaat"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-layout
                      row
                      wrap
                      style="max-height: 50px"
                      align-center
                      justify-center
                      fill-height
                    >
                      <v-flex xs7 sm7 md7>
                        <tarihim
                          v-model="
                            passRequest.PasaportDurumBilgi
                              .KonsoloslukCikisZamani
                          "
                          :etiket="this.$t('Consulate-Leaving-Date')"
                          :detaygizle="false"
                          v-bind:defaultvalue="
                            passRequest.PasaportDurumBilgi
                              .KonsoloslukCikisZamani
                          "
                        ></tarihim>
                      </v-flex>

                      <v-flex xs5 sm5 md5>
                        <v-text-field
                          v-model="konsoloslukCikisSaat"
                          :label="this.$t('Consulate-Leaving-Time')"
                          type="time"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="pasaportDurumuDialog = false">{{
            this.$t("Cancel")
          }}</v-btn>
          <v-btn color="info" flat @click="pasaportDurumuDegistir()">{{
            this.$t("OK")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import tarihim from "@/components/app/customcomp/tarihim";
import rez from "@/components/app/coper/rezervasyon.js";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import tool from "@/components/app/coper/tools";
import konsoloslukminiara from "@/components/app/coper/comp/konsoloslukminiara.vue";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import sirketkisiara from "@/components/app/customcomp/sirketkisiara";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import takipno from "@/components/app/coper/component/takipno.vue";

export default {
  data() {
    return {
     
      passRequest: {
        PasaportDurumBilgi: {
          IslemRef: 0,
          PasaportTip: 0,
          PasaportNo: null,
          VerildigiYer: null,
          VerilisTarihi: null,
          BitisTarihi: null,
          CocukVar: false,
          CocukVizeIstiyor: false,
          CocukId: 0,
          OfiseTeslimAlan: null,
          OfiseGelisTarihi: null,
          PasaportIslemDurumu: 0,
          KonsoloslukGirisZamani: null,
          TahminiCikisZamani: null,
          KonsoloslukCikisZamani: null,
          TeslimBilgisi: {
            TeslimTarihi: null,
            TeslimEden: null,
            EldenTeslim: null,
            KargoTeslim: {
              TeslimEdilenKargo: null,
              TeslimEdilenKargoFisNo: null,
              TeslimEdilenSube: null,
              TeslimEdilenSubeFisNo: null,
              TeslimEdilecekSube: null,
              TeslimEdilecekSubeFisNo: null,
            },
          },
        },
      },
      vizeDurumuRequest: {
        IslemRef: 0,
        VizeDurumu: 0,
        VizeNo: null,
        VizeBaslangic: null,
        VizeBitis: null,
      },
      tooltip:false,
      RequestData: {
        Filtreler: {
          PasaportIslemDurumu: 0,
          VizeIslemDurumu: 0,
          DegisiklikPasaportIslemDurumu: 0,
          DegisiklikVizeIslemDurumu: 0,
          Isim: null,
          Kayit_Tarihi1: null,
          Kayit_Tarihi2: null,
          Konsolosluk: null,
          PNR_No: null,
          PasaportBitisTarihi1: null,
          PasaportBitisTarihi2: null,
          VizeBitisTarihi1: null,
          VizeBitisTarihi2: null,
          DepartmanID: null,
          DegisiklikTarihi1: null,
          DegisiklikTarihi2: null,
          TakipNo: null,
          SearchText: null,
        },
        Paging: {
          SiralamaTip: 0,
          SayfaNo: 1,
          VeriAdet: 25,
        },
      },
      pasKonsAdi: null,
      konsoloslukGirisSaat: null,
      tahminiCikisSaat: null,
      konsoloslukCikisSaat: null,
      pasaportTipItems: rez.PasaportTipi(),
      pasaportDurumuDialog: false,
      vizeDurumuDialog: false,
      paginationDisabled: false,
      vmodelpagination: false,
      sayfalama: 1,
      pagenumber: 1,
      loadingmesaj: "",
      loadingvmodel: false,
      text1: null,
      snackbar: false,
      filter: false,
      pasaportIslemItems: rez.PasaportIslemDurumu(),
      vizeIslemItems: rez.VizeDurumu(),
      pasaportIslemItemsDialog: [
        {
          text: this.$t("All-v2"),
          value: 0,
        },
        {
          text: this.$t("Delivered"),
          value: 1,
        },
        {
          text: this.$t("At-Register-Preparation"),
          value: 2,
        },
        {
          text: this.$t("At-Consulate"),
          value: 3,
        },
        {
          text: this.$t("At-Register-Process-Completed"),
          value: 4,
        },
      ],
      vizeIslemItemsDialog: [
        {
          text: this.$t("All-v2"),
          value: 0,
        },
        {
          text: this.$t("Visa-Received"),
          value: 1,
        },
        {
          text: this.$t("At-Process"),
          value: 2,
        },
        {
          text: this.$t("Missing-Document"),
          value: 3,
        },
        {
          text: this.$t("Rejected-Returned"),
          value: 4,
        },
        {
          text: this.$t("At-Office"),
          value: 5,
        },
      ],
      itemsKonsolosluk: [],
      cardItems: [],
      vizeColor: null,
      pasaportColor: null,
      totalCountText: null,
      veriItem: [
        {
          Text: "25",
          Value: 25,
        },
        {
          Text: "50",
          Value: 50,
        },
        {
          Text: "100",
          Value: 100,
        },
      ],
      siralamaItems: [
        {
          Text: this.$t("PNR-Number-Ascending"),
          Value: 0,
        },
        {
          Text: this.$t("PNR-Number-Descending"),
          Value: 1,
        },
        {
          Text: this.$t("Record-Date-Ascending"),
          Value: 2,
        },
        {
          Text: this.$t("Record-Date-Descending"),
          Value: 3,
        },
        {
          Text: this.$t("Current-Code-Ascending"),
          Value: 4,
        },
        {
          Text: this.$t("Current-Code-Descending"),
          Value: 5,
        },
        {
          Text: this.$t("Visa-Start-Date-Ascending"),
          Value: 6,
        },
        {
          Text: this.$t("Visa-Start-Date-Descending"),
          Value: 7,
        },
        {
          Text: this.$t("Visa-End-Date-Ascending"),
          value: 8,
        },
        {
          Text: this.$t("Visa-End-Date-Descending"),
          value: 9,
        },
      ],
    };
  },

  methods: {
    pasaportDurumuDegistir() {
      let params = this.passRequest;
      if (
        this.passRequest.PasaportDurumBilgi.KonsoloslukGirisZamani != null &&
        this.konsoloslukGirisSaat.length > 0
      ) {
        this.passRequest.PasaportDurumBilgi.KonsoloslukGirisZamani =
          this.passRequest.PasaportDurumBilgi.KonsoloslukGirisZamani.substring(
            0,
            11
          ) +
          "T" +
          this.konsoloslukGirisSaat +
          ":00";
      }
      if (
        this.passRequest.PasaportDurumBilgi.TahminiCikisZamani != null &&
        this.tahminiCikisSaat.length > 0
      ) {
        this.passRequest.PasaportDurumBilgi.TahminiCikisZamani =
          this.passRequest.PasaportDurumBilgi.TahminiCikisZamani.substring(
            0,
            11
          ) +
          "T" +
          this.tahminiCikisSaat +
          ":00";
      }
      if (
        this.passRequest.PasaportDurumBilgi.KonsoloslukCikisZamani != null &&
        this.konsoloslukCikisSaat.length > 0
      ) {
        this.passRequest.PasaportDurumBilgi.KonsoloslukCikisZamani =
          this.passRequest.PasaportDurumBilgi.KonsoloslukCikisZamani.substring(
            0,
            11
          ) +
          "T" +
          this.konsoloslukCikisSaat +
          ":00";
      }
      tool.http_post(this, "PasaportDurumDegistir", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getListPageZero();
            this.pasaportDurumuDialog = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.pasaportDurumuDialog = false;
          }
        },
        (response) => {
          this.text1 = this.$t("Error-Occured-Please-Try-Again");
          this.snackbar = true;
          this.pasaportDurumuDialog = false;
        }
      );
    },
    pasaportDurumuDegistirDialogOpen(item) {
      this.pasKonsAdi = item.KonsAdi;
      this.passRequest.PasaportDurumBilgi.IslemRef = item.IslemRef;
      this.passRequest.PasaportDurumBilgi.PasaportTip = item.PasaportTip;
      this.passRequest.PasaportDurumBilgi.PasaportNo = item.PasaportNo;
      this.passRequest.PasaportDurumBilgi.VerildigiYer = item.VerildigiYer;
      this.passRequest.PasaportDurumBilgi.VerilisTarihi = item.VerilisTarihi;
      this.passRequest.PasaportDurumBilgi.BitisTarihi = item.BitisTarihi;
      this.passRequest.PasaportDurumBilgi.CocukVar = item.CocukVar;
      this.passRequest.PasaportDurumBilgi.CocukVizeIstiyor =
        item.CocukVizeIstiyor;
      this.passRequest.PasaportDurumBilgi.CocukId = item.CocukId;
      this.passRequest.PasaportDurumBilgi.OfiseTeslimAlan =
        item.PspOfsTeslimAlan;
      this.passRequest.PasaportDurumBilgi.OfiseGelisTarihi =
        item.OfiseGelisTarihi;
      this.passRequest.PasaportDurumBilgi.PasaportIslemDurumu =
        item.PasaportIslemDurumu;

      this.passRequest.PasaportDurumBilgi.KonsoloslukGirisZamani =
        item.KonsoloslukGirisZamani;
      this.passRequest.PasaportDurumBilgi.TahminiCikisZamani =
        item.TahminiCikisZamani;
      this.passRequest.PasaportDurumBilgi.KonsoloslukCikisZamani =
        item.KonsoloslukCikisZamani;

      if (item.KonsoloslukGirisZamani != null) {
        this.konsoloslukGirisSaat = item.KonsoloslukGirisZamani.substring(
          11,
          16
        );
      }
      if (item.KonsoloslukGirisZamani != null) {
        this.tahminiCikisSaat = item.TahminiCikisZamani.substring(11, 16);
      }
      if (item.KonsoloslukCikisZamani != null) {
        this.konsoloslukCikisSaat = item.KonsoloslukCikisZamani.substring(
          11,
          16
        );
      }

      this.passRequest.PasaportDurumBilgi.TeslimBilgisi.TeslimTarihi =
        item.TeslimTarihi;
      this.passRequest.PasaportDurumBilgi.TeslimBilgisi.TeslimEden =
        item.TeslimEden;

      this.pasaportDurumuDialog = true;
    },
    vizeDurumuDegistir() {
      let params = this.vizeDurumuRequest;
      tool.http_post(this, "VizeDurumDegistir", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getListPageZero();
            this.vizeDurumuDialog = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.vizeDurumuDialog = false;
          }
        },
        (response) => {
          this.text1 = this.$t("Error-Occured-Please-Try-Again");
          this.snackbar = true;
          this.vizeDurumuDialog = false;
        }
      );
    },
    vizeDurumuDegistirDialogOpen(item) {
      this.vizeDurumuRequest.IslemRef = item.IslemRef;
      this.vizeDurumuRequest.VizeDurumu = item.VizeIslemDurumu;
      this.vizeDurumuRequest.VizeNo = item.VizeNo;
      this.vizeDurumuRequest.VizeBaslangic = item.VizeBaslangicTarihi;
      this.vizeDurumuRequest.VizeBitis = item.VizeBitisTarihi;
      this.vizeDurumuDialog = true;
    },
    getVizeColor(val) {
      switch (val) {
        case 0:
          return "green";
          break;
        case 1:
          return "blue";
          break;
        case 2:
          return "warning";
          break;
        case 3:
          return "red";
          break;
        case 4:
          return "purple";
          break;
        default:
          break;
      }
    },
    getPasaportColor(val) {
      switch (val) {
        case 0:
          return "green";
          break;
        case 1:
          return "blue";
          break;
        case 2:
          return "warning";
          break;
        case 3:
          return "purple";
          break;
        default:
          break;
      }
    },
    getListPageZero() {
      this.filter = false;
      this.sayfalama = 1;
      this.getList();
    },
    getList() {
      this.loadingvmodel = true;
      this.loadingmesaj = "Vize Takip Listeleme";
      this.cardItems.length = 0;
      let params = this.RequestData;

      this.RequestData.Paging.SayfaNo = this.sayfalama;
      tool.http_post(this, "VizeTakipList", params).then(
        (response) => {
          if (response.body.Status == true) {
            if (response.body.PageTotals.TotalCount > 0) {
              this.totalCountText =
                response.body.PageTotals.TotalCount +
                " " +
                this.$t("Number-of-Records-Found");
              this.pagenumber = response.body.PageTotals.TotalPage;
              this.vmodelpagination = true;
              this.loadingvmodel = false;
            } else {
              this.totalCountText = this.$t("No-Records-Found");
              this.vmodelpagination = false;
              this.loadingvmodel = false;
            }
            this.cardItems = response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
          this.text1 = this.$t("Error-Occured-Please-Try-Again");
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },
    getListExcel() {
      this.loadingvmodel = true;
      this.loadingmesaj = "Vize Takip Listeleme";
      this.cardItems.length = 0;
      let params = this.RequestData;

      params.Paging.SayfaNo = -1;

      tool.api_post_FileDownload(this, "Coper/ExcelVizeTakip", params).then(
        (response) => {
          tool.CreateDownloadLink(response, "VizeTakip.xlsx");
          this.loadingvmodel = false;
        },
        (response) => {
          this.text1 = this.$t("Error-Occured-Please-Try-Again");
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },
  },

  filters: {
    getVizeDurumu: function (value, list) {
      let _resultText = null;
      list.forEach((element) => {
        if (element.value == value) {
          _resultText = element.text;
        }
      });
      return _resultText;
    },
    getPasaportDurumu: function (value, list) {
      let _resultPassText = null;
      list.forEach((element) => {
        if (element.value == value) {
          _resultPassText = element.text;
        }
      });
      return _resultPassText;
    },
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  watch: {
    sayfalama(value) {
      this.getList();
    },
  },
  components: {
    tarihim,
    rez,
    pnrbul,
    konsoloslukminiara,
    geneltipara,
    snackbarcomp,
    yetkidialog,
    loadingcomp,
    sirketkisiara,
    genelarama,
    takipno,
  },
};
</script>
